module.exports = __webpack_public_path__ + "img/approve-list15.45ea72cd.png";